// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-explicit-any
export function toDictionary<T extends Record<string, any>, K extends keyof T>(
  values: T[],
  key: K
): Map<T[K], T> {
  return new Map(values.map((value) => [value[key], value]))
}
